module.exports = "/Like@2x-9973403a209ebac923b865b270cf1fb1.png";